const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

//@Actions
const { handleFieldMultipleChange } = require('actions/brokerProductFiltersSearch');

//@Utilities
const { formatText } = require('core/i18n').i18n;
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

//@Constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_SIMPLE_SEARCH_PAGE_NUM,
    BROKER_PRODUCT_SEARCH_GROUP_LIMIT,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10,
    BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS,
    BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY,
    BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_RISK,
    BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE,
    BROKER_PRODUCT_ADVANCED_SEARCH_MARKET,
    BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER,
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
} = require('constants/index');

const searchProductsRequest = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_REQUEST,
        payload: {
            clearLastResult: true
        }
    };
};

const searchProductsRequestWithSavedFilters = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_REQUEST,
        payload: {
            clearLastResult: false
        }
    };
}

const sanitizeSuccessResponse = (response) => {
    function sanitize(productsList) {
        return {
            instrumentsList: productsList ? productsList.instrumentsList : [],
            total: productsList ? productsList.total : 0,
            totalPages: productsList ? productsList.totalPages : 0
        }
    }

    return {
        etfs: sanitize(response.etfs),
        stocks: sanitize(response.stocks),
        plans: sanitize(response.plans),
        warrants: sanitize(response.warrants),
        funds: sanitize(response.funds),
        alternativeFunds: sanitize(response.alternativeFunds),
        crypto: sanitize(response.cryptocurrencies),
    };
}

const searchProductsSuccess = (response, pageNumber, disableTealium) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_SUCCESS,
        payload: {
            data: sanitizeSuccessResponse(response),
            pageNumber,
            disableTealium
        }
    };
};

const searchProductsFailure = (response) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_FAILURE,
        payload: {
            data: response
        }
    };
};

const saveFilters = (query) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_SAVE_FILTERS,
        payload: {
            currentFilters: query
        }
    }
}

const searchSpecificIsin = (isin, disableTealium = false) => (dispatch) => {
    const header = __CONTACT_CENTER__ ? {
        isOfficeAgent: isPrintOfficeMode() ? 'office' : 'CC'
    } : null;

    let requestData = {
        header: header,
        query: {
            text: isin,
            pageSize: 1,
            pageNumber: 1
        }
    };

    dispatch(searchProductsRequest());
    
    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then(response => {
            dispatch(searchProductsSuccess(response, 1, disableTealium));
        }, response => {
            dispatch(searchProductsFailure(response));
        }
    );
};

const getResultsListRequest = (term, products, searchLimit, numberPage, searchLimitGroup = null) => (dispatch, getState) => {
    const immBrokerProductFiltersSearch = getState().brokerProductFiltersSearch;
    const combosConfiguration = getState().brokerProductFiltersSearch.getIn(['filters', 'combosConfiguration']);
    const assetClasses = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES]);
    const subAssetClass = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE]);
    const currency = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY]);
    const market = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MARKET]);
    const manager = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER]);
    const risk = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_RISK]);
    const pageNumber = numberPage ? numberPage : BROKER_SIMPLE_SEARCH_PAGE_NUM;

    const header = __CONTACT_CENTER__ ? {
        isOfficeAgent: isPrintOfficeMode() ? 'office' : 'CC'
    } : null;

    let requestData = {
        header: header,
        query: {
            text: term,
            products: products,
            pageSize: searchLimit,
            pageSizeGroup: searchLimitGroup,
            pageNumber: pageNumber
        }
    };

    if(assetClasses && assetClasses.size > 0 && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES)) {
        requestData.query.assetClasses = assetClasses.map((item) => item.value).toJS();
    }

    if(subAssetClass.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE)) {
        requestData.query.subAssetClass = subAssetClass.value
    }

    if(currency.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY)) {
        requestData.query.currency = currency.value
    }

    if(market.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_MARKET)) {
        requestData.query.market = market.value
    }

    if(manager.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER)) {
        requestData.query.manager = manager.value
    }

    if(risk.value !== BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS && combosConfiguration.get(BROKER_PRODUCT_ADVANCED_SEARCH_RISK)) {
        requestData.query.risk = risk.value
    }

    dispatch(searchProductsRequest());
    dispatch(saveFilters(requestData.query));

    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then(response => {
            dispatch(searchProductsSuccess(response, pageNumber));
        }, response => {
            dispatch(searchProductsFailure(response));
        }
    );
};

const clearResults = () => (dispatch) => {
    dispatch({type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_CLEAR});
    dispatch({type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_CLEAR});
};

const editSearch = (searchCollapsed = false) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_EDIT,
        payload: {
            searchCollapsed
        }
    };
};

const shouldSearch = (data) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_SHOULD_SEARCH,
        payload: {
            data
        }
    };
}

const searchProducts = (term, product, searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT) => (dispatch) => {
    dispatch(getResultsListRequest(term, product, searchLimit));
};

const advancedSearchProducts = (searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT, limitedProducts = []) => (dispatch, getState) => {
    const immBrokerProductFiltersSearch = getState().brokerProductFiltersSearch;
    const term = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);
    const productSize = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).size;
    let products;
    if (limitedProducts.length === 0 || productSize !== 0) {
        products = productSize ? immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).map((item) => item.value).toJS() : [];
    } else {
        products = limitedProducts;
    }


    dispatch(getResultsListRequest(term, products, searchLimit, null, BROKER_PRODUCT_SEARCH_GROUP_LIMIT));
};

const setSpecificProduct = (product) => (dispatch) => {
    dispatch(handleFieldMultipleChange(BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES, [{value: product, label: formatText(`brokerAdvancedSearch-brokerAdvancedSearch_${product}`)}]));
}

const searchSpecificProduct = (product, searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10) => (dispatch, getState) => {
    const immBrokerProductFiltersSearch = getState().brokerProductFiltersSearch;
    const term = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);

    dispatch(setSpecificProduct(product));
    dispatch(getResultsListRequest(term, product, searchLimit));
};

const retryAdvancedSearch = (limitedProducts = []) => (dispatch) => {
    dispatch(advancedSearchProducts(BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT, limitedProducts));
}

const retryAdvancedSearchSpecificProduct = (searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10) => (dispatch, getState) => {
    const immBrokerProductFiltersSearch = getState().brokerProductFiltersSearch;
    const product = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).get(0).value;
    dispatch(searchSpecificProduct(product, searchLimit));
}

const searchWithPage = (pageNumber) => (dispatch, getState) => {
    let savedFilters = getState().brokerProductAdvancedSearch.get('savedFilters');
    savedFilters.pageNumber = pageNumber;

    const header = __CONTACT_CENTER__ ? {
        isOfficeAgent: isPrintOfficeMode() ? 'office' : 'CC'
    } : null;

    let requestData = {
        header: header,
        query: savedFilters
    };

    dispatch(searchProductsRequestWithSavedFilters());
    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then(response => {
            dispatch(searchProductsSuccess(response, pageNumber));
        }, response => {
            dispatch(searchProductsFailure(response));
        }
    );
};

/*const searchWithPage = (pageNumber, searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10) => (dispatch, getState) => {
    const immBrokerProductFiltersSearch = getState().brokerProductFiltersSearch;
    const term = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM]);
    const products = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES]).map((item) => item.value).toJS()
    const clearLastResult = false;

    dispatch(getResultsListRequest(term, products, searchLimit,  clearLastResult, pageNumber));
}*/

const buyButtonClick = (dgsCode) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_BUY_BUTTON_CLICK,
        payload: {
            dgsCode
        }
    };
}

module.exports = {
    advancedSearchProducts,
    searchProducts,
    clearResults,
    editSearch,
    saveFilters,
    searchSpecificIsin,
    searchSpecificProduct,
    searchWithPage,
    retryAdvancedSearch,
    retryAdvancedSearchSpecificProduct,
    buyButtonClick,
    shouldSearch,
    setSpecificProduct
};
